<template>
<a href="javascript:void(0)" :class="current" :data-scp="scp" @click.stop="add()">
	<i class="icon icon-roundaddfill"></i><span>发布</span>
</a>
</template>
<script>
import maple from 'maple';
export default {
	props: ['current', 'scp']
	, methods: {
		add: function(){
			if( maple.device.weixin ){
				location.href = '/fittingShow/fabushiyixiu.html';
			}
			else{
				maple.confirm({
					content:'请使用APP体验发布试衣秀功能，点击确定下载APP！',
					okFn:function(){
						location.href="/index/loadAndroid.html"
					}
				})
			}
		}
	}
};
</script>